<template>
  <div id="mai-profile">
    <div class="caseinfo"  v-if="caseInfo.id">
      <div class="header">
        Case Info
      </div>
      <div class="body">
        <div class="icon-container"><i class="fa fa-folder"></i>{{ caseInfo.id }}</div>
        <div class="icon-container"><i class="fa fa-user"></i>{{ caseInfo.name }}</div>
        <div class="icon-container"><i class="fa fa-briefcase"></i>{{ caseInfo.type }}</div>
        <div class="icon-container"><i class="fa fa-list-alt"></i>{{ caseInfo.assignment }}</div>
        <div class="icon-container"><i class="fa fa-compass"></i>{{ caseInfo.location }}</div>
      </div>
    </div>
    <div class="participants mt-15">
      <div class="header">
        Contacts
      </div>
      <div class="body">
        <template v-if="participants.length > 0">
          <div v-for="p in participants" :key="p.id">
            <div>
              <i class="fa fa-circle" :class="{ 'status-online': p.online, 'status-offline': !p.online }"></i>
              {{ p.name }}
            </div>
          </div>
        </template>
        <template v-else>
          <p class="text-center">
            No contacts to show
          </p>
        </template>
      </div>
    </div>
    <div class="profile mt-15">
      <div class="body">
        <div>
          <i class="fa fa-user-circle avatar"></i>
          <span style="vertical-align:middle;position:relative;top:-.7em;">{{userInfo.fullname}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Contacts from './ChatContacts'
import Conversation from './ChatConversation'
export default {
  name: 'MaiChat',
  props: {
    participants: {
      type: Array,
      required: true
    },
    caseInfo: {
      type: Object,
      required: true
    },
    userInfo: {
      type: Object,
      required: true
    }
  },
  components: {
    Contacts,
    Conversation
  },
  data () {
    return {
      fullname: ''
    }
  },
  computed: {
    bottom () {
      return `${this.dimensions.bottom}px`
    },
    right () {
      return `${this.dimensions.right}px`
    }
  },
  methods: {
    drag ({ screenX, screenY }) {
      this.initial.x = screenX
      this.initial.y = screenY
    },
    drop ({ screenX, screenY }) {
      this.end.x = screenX
      this.end.y = screenY
      this.updatePosition()
    },
    updatePosition () {
      this.dimensions.right += this.initial.x - this.end.x
      this.dimensions.bottom += this.initial.y - this.end.y
    },
    onSelection (selection) {
      this.viewing = 'conversation'
    },
    send (msg) {
      this.conversation.push(
        { id: this.id++, from: 1, to: 2, content: msg, time: new Date().getTime() }
      )
      this.message = ''
      setTimeout(this.reply, 1500)
    },
    reply () {
      this.conversation.push(
        { id: this.id++, from: 2, to: 1, content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales.', time: new Date().getTime() }
      )
    }
  },
  watch: {
    viewing (newVal, oldVal) {
      this.conversation = [ ...this.demo ]
      this.message = ''
    }
  },
  mounted () {
    this.username = this.$route.query.userId
    this.topic = this.$route.query.topic
  }
}
</script>
<style lang="scss">
#mai-profile {
  .caseinfo, .participants, .profile {
    .header {
      font-size: 1.8em;
      font-weight: bold;
      text-transform: uppercase;
      color: #0ea4f1;
    }
    .body {
      font-size: 1.5em;
      margin-top: 10px;
      padding-top: 15px;
      border-top: 1px solid #dddddd;

      .icon-container {
        margin-bottom: 5px;

        i {
          width: 30px;
          text-align: center;
          margin-right: 10px;
        }
      }
    }
  }
  .fa {
    padding-right: 5px;
  }
  .avatar {
    font-size: 40px;
  }
  .status-online {
    color: #67C23A;
  }
  .status-offline {
    color: #949494;
  }
  .mt-15 {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/MaiProfile.vue